import { Box, Button, IconButton } from '@mui/material'
import InfiniteScroll from 'react-infinite-scroll-component'
import { styled } from '@mui/material/styles'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor, GetRGBA } from 'src/utils'

export const SelectedDrawingSection = styled(Box)(({ theme }) => ({
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: 4,
  overflow: 'hidden',
}))

export const SelectedDrawingHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  minHeight: 44,
  padding: theme.spacing(0.5, 1.5),
  borderBottom: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
}))

export const RemovePositionDrawingButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,
  textTransform: 'none',
  color: getThemeColor(theme, MUIThemeColors.errorMain),
  borderColor: getThemeColor(theme, MUIThemeColors.errorMain),
  '&:hover': {
    backgroundColor: getThemeColor(theme, MUIThemeColors.errorLight),
    borderColor: getThemeColor(theme, MUIThemeColors.errorDark),
    color: getThemeColor(theme, MUIThemeColors.white),
  },
}))

export const ImgBox = styled(Box)({
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  width: '100%',
})

export const PreviewNavButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1,
  color: getThemeColor(theme, MUIThemeColors.black),
  backgroundColor: GetRGBA(getThemeColor(theme, MUIThemeColors.white), 0.8),
  boxShadow: theme.shadows[2],
  '&:hover': {
    backgroundColor: GetRGBA(getThemeColor(theme, MUIThemeColors.white), 0.95),
  },
  '&.Mui-disabled': {
    opacity: 0,
    pointerEvents: 'none',
  },
  '&.prev': { left: 8 },
  '&.next': { right: 8 },
}))

export const SelectedPositionDrawingPreview = styled(ImgBox, {
  shouldForwardProp: prop => prop !== 'imageUrl',
})<{ imageUrl?: string }>(({ theme, imageUrl }) => ({
  backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
  backgroundColor: imageUrl
    ? getThemeColor(theme, MUIThemeColors.infoLight)
    : getThemeColor(theme, MUIThemeColors.white),
  backgroundSize: 'contain',
  height: 420,
  position: 'relative',
}))

export const PositionDrawingThumbnailFrame = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ theme, isSelected }) => ({
  position: 'relative',
  height: 100,
  width: 125,
  padding: '2px',
  borderRadius: '10px',
  border: `3px solid ${isSelected ? getThemeColor(theme, MUIThemeColors.primaryLight) : 'transparent'}`,
}))

export const ImgContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 4,
  width: '100%',
  padding: 2,
  cursor: 'pointer',
})

export const ImgList = styled(InfiniteScroll)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
  alignContent: 'flex-start',
  gap: 4,
  width: '100%',
  height: 180,
  padding: 8,
  boxSizing: 'border-box',
  overflowY: 'auto',
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: 4,
}))
